import { z } from "zod";

export const levelSchema = () => {
  return z.object({
    name: z.string().min(1),
    rank: z.string().min(1),
  });
};

export type LevelFormValues = z.infer<ReturnType<typeof levelSchema>>;
